document.addEventListener('DOMContentLoaded', function() {
  const sources = document.querySelectorAll(".store-list-area.merge .store-list-area__store-list");
  sources.forEach(source => {
    const target = document.querySelector(`.store-list-area.target .store-list-area__store-list[data-prefecture="${source.dataset.prefecture}"]`);
    if (!target) return;
    while(source.firstChild) {
      target.appendChild(source.firstChild);
    }
  });

  const prefectures = document.querySelectorAll(".store-list-area__prefecture");
  prefectures.forEach(prefecture => {
    const nextElement = prefecture.nextElementSibling;
    if (nextElement && nextElement.children.length === 0) {
      prefecture.parentNode.classList.add('disabled');
    }
    prefecture.addEventListener('click', e => {
      const clickedParentNode = e.target.parentNode;
      clickedParentNode.classList.toggle('active');
    });
  });

  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = document.getElementById(href.replace('#', ''));
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap = document.querySelector('store-header').offsetHeight;
      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  }
});